const ddadosDadosSolicitante = {
  Titulo: 'Dados Solicitante',
  Campos: {
    //Dados do Solicitante
    CpfCnpjSolicitante: {
      Tipo: 'mask',
      Mascara: 'CPFCNPJ',
      Label: 'CPF/CNPJ',
      Obrigatorio: true,
    },
    Nome: {
      Tipo: 'text',
      Label: 'Nome',
      Tamanho: 255,
      Obrigatorio: true,
    },
    Email: {
      Tipo: 'text',
      TipoInput: 'email',
      Label: 'E-mail',
      Tamanho: 80,
      Obrigatorio: true,
    },
    Telefone: {
      Tipo: 'mask',
      Mascara: 'DYNAMIC',
      Label: 'Telefone',
      Obrigatorio: true,
    },
    Celular: {
      Tipo: 'mask',
      Mascara: 'DYNAMIC',
      Label: 'Celular',
      Obrigatorio: true,
    },
    RgIe: {
      Tipo: 'text',
      Label: 'RG/IE',
      Mask: 'RG',
      Tamanho: 50,
    },
  },
};

export { ddadosDadosSolicitante };
